<script>
import i18n from "@/i18n";
import {mapActions, mapState} from "pinia";
import {takeOverStore} from "@/store/takeOverStore";
import {bankIdStore} from "@/store/bankIdStore";
import {successMessageStore} from "@/store/successMessageStore";
import Dialog from "primevue/dialog";

export default {
  name: "TakeOverConfirmModal",
  components: {
    Dialog
  },
  computed: {
    ...mapState(takeOverStore, [
        'takeOverModalState'
    ]),
    modalState: {
      get() {
        return this.takeOverModalState;
      },
      set() {
        this.closeModal();
      },
    },
  },
  methods: {
    ...mapActions(takeOverStore,[
        "openTakeOverModal",
        "closeTakeOverModal"
    ]),
    ...mapActions(bankIdStore, [
      'checkBankIdAuthSession'
    ]),
    ...mapActions(successMessageStore, [
      'showSuccessMessage'
    ]),
    closeModal() {
      this.closeTakeOverModal();
    },
    takeOverAccount() {
      console.log("takeOverAccount")

      this.closeTakeOverModal();
      this.checkBankIdAuthSession(
          () => {
            localStorage.removeItem('notAuthTakeOverProcess');
            this.showSuccessMessage(i18n.global.t('takeOver.successfullyMerged'), 500);
            setTimeout(()=>{
              window.location.reload();
            }, 1500);
          },
          null,
          (error) => {
            const status = error.response.status;
            if (status === 403) {
              // TODO: valekseev: 7/16/2025: take over is principal impossible - we have to highlight that in some modal
            }
          }
      );
    }
  }
}
</script>

<template>
  <Dialog v-model:visible="modalState"
          class="take-over-modal"
          modal
          :header="$t('takeOver.takeOverAccount.title')"
  >
    <div>
      <p class="mb-10">{{$t('takeOver.takeOverAccount.p1')}}</p>
      <p>{{$t('takeOver.takeOverAccount.p2')}}</p>
    </div>
    <template #footer>
      <button type="button" class="p-dialog-close-btn" @click="closeModal()">
        {{$t('common.buttons.cancel')}}
      </button>
      <button type="button" class="p-dialog-primary-btn" @click="takeOverAccount()">
        {{$t('takeOver.takeOverAccount.btnText')}}
      </button>
    </template>
  </Dialog>
</template>

<style lang="scss">
.take-over-modal {
  max-width: 550px;
  .p-dialog-content {
    padding: 20px;
    line-height: 16px;
  }
}

</style>